import { render, staticRenderFns } from "./TitleImageDescriptionLayout.vue?vue&type=template&id=495022f6&scoped=true"
import script from "./TitleImageDescriptionLayout.vue?vue&type=script&lang=ts"
export * from "./TitleImageDescriptionLayout.vue?vue&type=script&lang=ts"
import style0 from "./TitleImageDescriptionLayout.vue?vue&type=style&index=0&id=495022f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495022f6",
  null
  
)

export default component.exports